var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLiqualityLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 15,
    viewBox: "0 0 104 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_332_1730)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.289 11.9015H46.5227V3.50332H45.289V11.9015ZM46.7085 0.850187C46.7085 1.32507 46.3575 1.69671 45.8929 1.69671C45.4284 1.69671 45.0774 1.33023 45.0774 0.850187C45.0774 0.35466 45.4284 0.00366211 45.8929 0.00366211C46.3575 0.00882384 46.7085 0.359822 46.7085 0.850187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.0358 7.71532C56.0358 5.86226 54.7763 4.52021 53.0007 4.52021C51.2095 4.52021 49.9501 5.86226 49.9501 7.71532C49.9501 9.56839 51.2095 10.8949 53.0007 10.8949C54.7763 10.9001 56.0358 9.56839 56.0358 7.71532ZM57.2797 3.50335V15.0037H56.0358V10.1C55.4112 11.2821 54.2653 11.9686 52.7581 11.9686C50.363 11.9686 48.7009 10.1981 48.7009 7.68951C48.7009 5.18091 50.363 3.44141 52.7374 3.44141C54.2395 3.44141 55.406 4.12792 56.0254 5.32544V3.50335H57.2797Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.6961 3.50342V11.9067H66.4522V10.0072C65.8947 11.3131 64.7746 11.9429 63.2571 11.9532C61.2956 11.9532 60.1084 10.7092 60.1084 8.67548V3.50342H61.3524V8.36061C61.3524 9.86268 62.2299 10.7557 63.6803 10.7557C65.425 10.7195 66.447 9.44457 66.447 7.62248V3.50342H67.6961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.199 8.03536V7.39531C77.0544 5.70226 75.8414 4.52022 74.1794 4.52022C72.3882 4.52022 71.1288 5.86227 71.1288 7.71533C71.1288 9.5684 72.3882 10.895 74.1794 10.895C75.8414 10.9001 77.0544 9.72841 77.199 8.03536ZM78.443 3.50336V11.9067H77.1938V10.1155C76.5692 11.2821 75.4233 11.9686 73.9368 11.9686C71.5417 11.9686 69.8796 10.1981 69.8796 7.68953C69.8796 5.19641 71.5262 3.44142 73.8903 3.44142C75.4079 3.42593 76.5589 4.11244 77.1938 5.29448V3.50336H78.443Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.6486 11.9015H86.8823V3.50332H85.6486V11.9015ZM87.0732 0.850187C87.0732 1.32507 86.7223 1.69671 86.2577 1.69671C85.7931 1.69671 85.4421 1.33023 85.4421 0.850187C85.4421 0.35466 85.7931 0.00366211 86.2577 0.00366211C86.7223 0.00882384 87.0732 0.359822 87.0732 0.850187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.7476 11.3286C93.1385 11.7312 92.4881 11.9531 91.8635 11.9531C90.5834 11.9531 89.6904 11.0602 89.6904 9.25356V0.029541H90.9241V3.50339H93.4224V4.73704H90.9241V9.04709C90.9241 10.2446 91.3267 10.8021 92.0597 10.8021C92.4778 10.8021 92.9268 10.6421 93.3862 10.3737L93.7476 11.3286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.3181 11.886H82.5518V-0.00146484H81.3181V11.886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8293 11.886H42.063V-0.00146484H40.8293V11.886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.235 3.57568V10.9879C103.235 13.4862 101.702 15.0244 99.1982 15.0141C97.9439 14.9831 96.6173 14.4618 95.7759 13.6514L96.1528 12.7481C96.9115 13.4449 98.0058 13.9043 99.0846 13.9559C100.902 13.9559 102.001 12.8462 102.001 10.9776V9.44458C101.449 10.6008 100.416 11.2047 98.9401 11.2151C96.8496 11.2151 95.585 9.9814 95.585 7.96832V3.57568H96.8186V7.64829C96.8186 9.13487 97.7064 10.0279 99.1982 10.0279C100.969 9.99688 102.001 8.7942 102.001 6.82758V3.57568H103.235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.76015 1.71373C1.74983 1.72405 1.74467 1.72922 1.73434 1.73954C0.820716 2.66865 0.263248 3.82488 0.077426 5.0224C0.0258087 5.32695 0 5.63149 0 5.94635V5.98249C0 6.2767 0.0258087 6.57609 0.0671026 6.8703C0.201308 7.78393 0.552306 8.67175 1.10977 9.45117C1.29043 9.70926 1.50206 9.95702 1.73434 10.1945C1.74467 10.2048 1.74983 10.2099 1.76015 10.2203C2.26084 10.721 2.81831 11.1081 3.41191 11.3817C5.59532 12.3934 8.25361 11.9288 10.2409 10.2358C10.246 10.2306 10.2512 10.2254 10.2564 10.2254C12.5017 8.30527 14.5613 6.56576 16.7808 6.56576C18.9952 6.56576 21.0599 8.30527 23.3001 10.2254C23.9092 10.7468 24.5802 11.1545 25.2873 11.4333C26.2061 11.8049 27.1765 11.9649 28.1315 11.8978C29.4683 11.8049 30.7588 11.2629 31.8014 10.2203C31.8118 10.2099 31.8169 10.2048 31.8273 10.1945C32.0595 9.96218 32.266 9.71442 32.4518 9.45117C33.0093 8.66659 33.3603 7.77877 33.4945 6.8703C33.5874 6.26122 33.5822 5.63665 33.4893 5.02757C33.3035 3.82488 32.746 2.67381 31.8324 1.7447C31.8221 1.73438 31.8169 1.72922 31.8066 1.71889C30.7691 0.681384 29.4787 0.139402 28.1366 0.046491C27.1817 -0.0154498 26.2061 0.144564 25.2822 0.516209C24.5802 0.794943 23.904 1.20272 23.3001 1.71889C21.0444 3.62874 19.0055 5.37856 16.7808 5.37856C14.5561 5.37856 12.5017 3.62357 10.2512 1.71373C10.246 1.70857 10.2409 1.70341 10.2409 1.70341C8.95045 0.614282 7.37612 0.0310059 5.83276 0.0310059C4.99656 0.0310059 4.17068 0.201343 3.40674 0.557503C2.81831 0.831075 2.25568 1.21304 1.76015 1.71373Z",
    fill: "url(#paint0_radial_332_1730)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_332_1730",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-2.24058 5.96883) scale(38.414 20.8594)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CE5C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1025,
    stopColor: "#1CE5C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4747,
    stopColor: "#5440D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6308,
    stopColor: "#8B2CE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7957,
    stopColor: "#D421EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC39FD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_332_1730"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 103.235,
    height: 15,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiqualityLogo);
export default __webpack_public_path__ + "static/media/liquality_logo.75b3ffcda6ba36835064a9fd9a20d9cb.svg";
export { ForwardRef as ReactComponent };